import { initializeApp, type FirebaseApp } from "@firebase/app";
import { getAuth, type Auth } from "@firebase/auth";
import { getStorage, type FirebaseStorage } from "@firebase/storage";
import { localDemoEnabled } from "./local-demo";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);

let app: FirebaseApp | null = null;
export let auth: Auth | null = null;
export let storage: FirebaseStorage | null = null;

if (isFirebaseConfigured && !localDemoEnabled) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  storage = getStorage(app);
}
